import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function MapIcon(props) {
  return (
    <SvgIcon
      viewBox="0 0 18 20"
      {...props}
      sx={{
        '& path:nth-of-type(1)': {
          fill: '#DADADA',
          transition: 'fill 0.2s ease',
        },
        '& path:nth-of-type(2)': {
          fill: '#373737',
          transition: 'fill 0.2s ease',
        },
        '& path:nth-of-type(3)': {
          fill: '#DADADA',
          transition: 'fill 0.2s ease',
        },
        '&:hover path:nth-of-type(1)': {
          fill: '#D4D5FC',
        },
        '&:hover path:nth-of-type(2)': {
          fill: '#4D44D8',
        },
        '&:hover path:nth-of-type(3)': {
          fill: '#D4D5FC',
        },
        ...props.sx,
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6221 13.0626H2.37713L0 19.0332H18L15.6229 13.0609L15.6221 13.0626Z"
      />
      <path
        d="M9.17481 15.6874C9.17481 15.6874 15.0678 11.0389 15.0678 6.89391C15.0686 3.6784 12.8581 0.967163 9.17481 0.967163C5.49067 0.967163 3.28101 3.6784 3.28101 6.89391C3.28101 11.0389 9.17481 15.6874 9.17481 15.6874Z"
      />
      <path
        d="M7.74512 4.94189H10.6042V7.94865H7.74512V4.94189Z"
      />
    </SvgIcon>
  );
}

export default MapIcon;
